export default __webpack_public_path__ + "static/media/usa.42b507d3.mp4";